import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { TimerError } from "@/modules/candidate/assessment/CandidateAssessment/utils/timerError.utils";
import { AssessmentCopy } from "@/modules/candidate/assessmentCopy";

export function TimerErrorModal({ error }: { error: TimerError }) {
  return (
    <BasicModal
      autoHeight={true}
      isModalOpen={!!error.message}
      isClosable={false}
      footer={false} /** No footer, to force candidates to take the suggested actions to move forward */
    >
      {error.message && (
        <p>
          <AssessmentCopy variants={error.message} />
        </p>
      )}
    </BasicModal>
  );
}
